/*
 *
 * CheckUserEmail actions
 *
 */

import {
  FLUSH_STATE_CHECKUSEREMAIL,
  CHANGE_CHECKUSEREMAIL,
  CHANGE_CHECKUSEREMAIL_SUCCESS,
  CHANGE_CHECKUSEREMAIL_ERROR,
} from './constants';

/**
 * Clearing the state for CheckUserEmail
 */
export function flushStateCheckUserEmail() {
  return {
    type: FLUSH_STATE_CHECKUSEREMAIL,
  };
}


/**
 * ------------------ CHANGE ------------------
 */

/**
 * Change/Update the CheckUserEmail, this action starts the request saga
 *
 * @return {array} An action object with a type of CHANGE_CHECKUSEREMAIL
 */
export function changeCheckUserEmail(checkUserEmailData) {
  return {
    type: CHANGE_CHECKUSEREMAIL,
    checkUserEmailData,
  };
}

/**
 * Dispatched when the changeCheckUserEmail are changed/updated by the request saga
 *
 * @param  {array} variables true for CheckUserEmail
 *
 * @return {array} An action object with a type of CHANGE_CHECKUSEREMAIL_SUCCESS passing the variables
 */
export function changeCheckUserEmailSuccess(checkUserEmailData) {
  return {
    type: CHANGE_CHECKUSEREMAIL_SUCCESS,
    checkUserEmailData,
  };
}

/**
 * Dispatched when loading the changeCheckUserEmail fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of CHANGE_CHECKUSEREMAIL_ERROR passing the error
 */
export function changeCheckUserEmailError(error) {
  return {
    type: CHANGE_CHECKUSEREMAIL_ERROR,
    error,
  };
}
